import { http, authHeader } from '@/http-commons';

class ClienteSucursalDataService {
     
    findAllByClient( clientId ){
        return http.get(`api/v1/cliente/sucursal/findAllByClient/${clientId}`, { headers: authHeader() });
    }

}

export default new ClienteSucursalDataService();